import { ROLE, ROLE_LABELS } from '../../../../lib/types';
import { sortRoles } from '../../../../utils/role.helpers';

export const rolesToString = (roles?: ROLE[]) => (roles?.length ? ROLE_LABELS[[...roles].sort(sortRoles)[0]] : '');
